import React, { FC, PropsWithChildren } from 'react';
import { DataAttribsForElParams, dataAttribsForEl, formatClassName } from '../../../utils';
import { FAIcon, IFAIconProps } from '../../fa-icon';
import { Icon as CoreIcon, Typography as CoreTypography, Layout as CoreLayout } from '../../../core';
import { tokens } from '@everfi/design-system';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

export type CardTitleProps = {
  chakra?: string;
  className?: string;
  icon?: IFAIconProps['icon'];
  iconSize?: IFAIconProps['size'];
  isDismissable?: boolean;
  size?: 14 | 16 | 18;
  titleDataAttributes?: DataAttribsForElParams;
  type?: 'mini' | 'narrow' | 'medium' | 'wide' | 'extra-wide';
  secondaryDetail?: React.ReactNode;
  attentionGrabber?: React.ReactNode;
} & PropsWithChildren;

export const CardTitle: FC<CardTitleProps> = props => {
  const {
    chakra, // TODO this isn't on by default, issues with foundry h3 interfering styles
    children,
    className,
    icon,
    iconSize = 'medium',
    size,
    titleDataAttributes: { context = {}, optionalAttributes } = {},
    type,
    secondaryDetail,
    attentionGrabber,
    isDismissable,
  } = props;

  const dataAttributes = dataAttribsForEl(context, optionalAttributes);
  const TitleTag = type === 'mini' ? 'h4' : 'h3';
  const iconSizes = {
    small: 'sm',
    medium: 'md',
    large: 'lg',
    extralarge: 'xl',
  };
  return chakra === 'on' ? (
    <CoreLayout {...dataAttributes}>
      <CoreLayout
        paddingRight={isDismissable ? tokens.SpacingBaseLg : 0}
        variant="flex"
        flexDirection="row"
        alignItems="flex-start"
      >
        {icon && (
          <CoreLayout paddingRight={tokens.SpacingBaseSm} variant="flex" alignItems="center" flexDirection="row">
            <CoreIcon iconName={icon} size={iconSizes[iconSize] as SizeProp} />
          </CoreLayout>
        )}
        <CoreTypography data-action="card-title" variant={TitleTag} style={{ marginTop: 0 }}>
          {children}
        </CoreTypography>
      </CoreLayout>
      {secondaryDetail}
      {attentionGrabber}
    </CoreLayout>
  ) : (
    <TitleTag
      className={formatClassName(['card-title', `card-title-${size}`, 'm-t-0', className])}
      {...dataAttributes}
      data-action="card-title"
    >
      {icon && <FAIcon icon={icon} size={iconSize} additionalClasses="title-icon" />}
      {children}
    </TitleTag>
  );
};

CardTitle.displayName = 'CardTitle';
